import React from 'react'

export default function OptionAnanlysisTable(props) { 
  if(!props?.data)
    return null;
  return (
    <div className="table-responsive">
          <table className="table table-bordered "> 
                                    <thead>
                                    <tr  className="header-row">
                                            <th >Symbol</th>
                                            <th >{props?.rowName} </th>
                                            <th >Strike</th>
                                            <th >Type</th>
                                        </tr>
                                    </thead>
                                    <tbody  >
                                        {props?.data?.map((value,key)=>(
                                            <tr key={`${props?.keyname}-${key}`} className="table_rows"  >
                                            <td  > {value?.symbol} </td>
                                            <td > {value?.columnKey} </td>
                                            <td > {value?.strike_prcie} </td>
                                            <td className={value?.option_type === 'PE' ?'redTxts':'greenTxts'}  > {value?.option_type} </td>
                                        </tr>
                                        ))}
                                        
                                    </tbody>
                                </table>
                                </div>
  )
}
